import { MarketIntelligencePages } from '@/routes/MarketIntelligencePages'
import { AuthPages } from './AuthPages'
import { MenusPageTabs } from './MenusPageTabs'

export const PATHS = {
  root: '/',
  accountSuspended: '/account-suspended',
  homePage: '/home',

  [AuthPages.signInPage]: '/auth',
  [AuthPages.forgotPasswordPage]: '/auth/forgot',
  [AuthPages.resetPasswordPage]: '/auth/reset',
  [AuthPages.newPasswordPage]: '/auth/new-password',
  [AuthPages.signUpPage]: '/auth/signup',

  analyticsPage: '/analytics',
  searchAppearancesPage: '/analytics/search-appearances',
  userProfilePage: '/user-profile',

  accountConnectionsPage: '/settings/connections',
  userManagementPage: '/settings/user-management',

  emailReportsPage: '/analytics/reports',
  emailReport: '/analytics/report',
  emailReportPage: '/email-reports',

  listingsPage: '/listings',
  locationsPage: '/locations',
  locationDetailsPage: '/locations/:id',

  [MenusPageTabs.menusPage]: '/menus',
  [MenusPageTabs.sectionsPage]: '/sections',
  [MenusPageTabs.itemsPage]: '/items',
  [MenusPageTabs.modifiersPage]: '/modifiers',
  [MenusPageTabs.choicesPage]: '/choices',

  menuDetailsPage: '/menus/:id',
  sectionDetailsPage: '/sections/:id',
  modifierDetailsPage: '/modifiers/:id',
  choiceDetailsPage: '/choices/:id',

  reviewsPage: '/reviews/monitoring',

  reviewLabelsPage: '/reviews/labels',

  reviewResponsePromptsPage: '/reviews/response-prompts',
  reviewResponsePrompt: '/reviews/response-prompt',
  reviewsResponseSettingsPage: '/reviews-response-settings',

  reviewNotificationsPage: '/reviews/notifications',
  reviewNotification: '/reviews/notification',
  reviewNotificationPage: '/review-notifications',

  reviewTemplatesPage: '/reviews/templates',
  reviewTemplatePage: '/reviews/template',

  reviewGenerationPage: '/reviews/generation',

  firstPartyReviewsFte: '/first-party',
  firstPartyReviews: '/first-party/forms',
  firstPartyReviewsForm: '/first-party/form',

  [MarketIntelligencePages.locationsTable]: '/market-intelligence',
  [MarketIntelligencePages.competitorsByLocations]: '/market-intelligence/:id',

  reviewAnalysis: '/reviews/review-analysis',
  sentimentAnalysis: '/reviews/sentiment-analysis',
  keywordAnalysis: '/reviews/keyword-analysis',

  publishedTab: '/social-management/published',
  scheduledTab: '/social-management/scheduled',
  draftsTab: '/social-management/drafts',
  choosePublisher: `/social-management/create-post`,
  createApplePost: `/social-management/create-post/apple`,
  createFacebookPost: `/social-management/create-post/facebook`,
  createGooglePost: `/social-management/create-post/google`,
  editPost: '/social-management/edit-post/:id',

  widgetsList: '/widgets',
  widgetFte: '/widgets/create',
  hourWidget: '/widgets/hour',
  menuWidget: '/widgets/menu',

  notFoundPage: '/not-found',
  forbiddenPage: '/forbidden',
  anyOtherPath: '*',
} as const
